import { PageAction, UsePageState } from './types';
import { DEFAULT_FIRST_PAGE, PageTypes, PageViewType } from '../../types';

export const defaultState = {
  currentPage: DEFAULT_FIRST_PAGE[PageTypes.Default],
  noOfPages: PageViewType.TwoPage,
  contentType: 'book',
  zoomed: false,
  totalPages: 0,
  showCover: false,
  firstPage: DEFAULT_FIRST_PAGE[PageTypes.Default],
  lockForOnePageView: false,
};

export const pageReducer = (state: UsePageState, action: PageAction): UsePageState => {
  switch (action.type) {
    case 'GO_LEFT':
      return {
        ...state,
        currentPage: action.payload.currentPage,
        showCover: action.payload.showCover,
      };
    case 'GO_RIGHT':
      return {
        ...state,
        currentPage: action.payload.currentPage,
        showCover: false,
      };
    case 'GO_TO_PAGE':
      return {
        ...state,
        currentPage: action.payload.currentPage,
        showCover: false,
      };
    case 'SET_NO_OF_PAGES_DISPLAYED':
      return {
        ...state,
        currentPage:
          action.payload.noOfPages === PageViewType.OnePage || state.currentPage === state.firstPage
            ? state.currentPage
            : state.currentPage - (state.currentPage % 2),
        noOfPages: action.payload.noOfPages,
      };
    case 'SET_PAGE_CONTENT':
      return { ...state, contentType: action.payload.contentType };
    case 'SET_PAGE_ZOOM':
      return { ...state, zoomed: action.payload.zoomed };
    case 'SET_NO_OF_TOTAL_PAGES':
      return { ...state, totalPages: action.payload.totalPages };
    case 'SET_SHOW_COVER':
      return {
        ...state,
        showCover: action.payload.showCover,
        currentPage: action.payload.showCover ? state.firstPage : state.currentPage,
      };
    case 'RESET_CURRENT_PAGE_NO':
      return { ...state, currentPage: state.firstPage };
    case 'RESET_ZOOM':
      return { ...state, zoomed: false };
    case 'RESET_NO_OF_PAGES':
      return { ...state, noOfPages: defaultState.noOfPages };
    case 'RESET_STATE':
      return {
        ...defaultState,
        currentPage: state.firstPage,
        firstPage: state.firstPage,
      };
    case 'SET_DEFAULT_FIRST_PAGE':
      return {
        ...state,
        firstPage: action.payload.firstPage,
        currentPage: action.payload.firstPage,
      };
    case 'SET_LOCK_FOR_ONE_PAGE_VIEW':
      return {
        ...state,
        lockForOnePageView: action.payload.lockForOnePageView,
        noOfPages: action.payload.lockForOnePageView
          ? PageViewType.OnePage
          : defaultState.noOfPages,
      };
  }
};
